import bootbox from "bootbox";

export default {
    confirm(message, callback) {
        bootbox.confirm({
            message: message,
            backdrop: true,
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Continue',
                    className: "btn btn-success"
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancel',
                    className: "btn btn-danger"
                }
            },
            callback: result => {
                if (result) callback();
            }
        });
    }
}
